import React from 'react';
import { Card, CardDeck, Button } from 'react-bootstrap'

export default function AboutUs() {
    return (
        <div>
            <CardDeck style={{ marginTop: 30, marginLeft: 30 }}>
                <Card style={{ height: 400 }}>
                    <Card.Body>
                        <Card.Text><b>RUDRAX VARIYA</b></Card.Text>
                        <Card.Text>
                            Computer Engineer
                        </Card.Text>
                        <Card.Text>
                            Front End Devloper
                        </Card.Text>
                    </Card.Body><i class=""></i>
                    <Card.Footer>
                    <a href="https://www.linkedin.com/in/rudrax-variya-4675a1142"><i class="fa fa-linkedin-square" style={{color:"blue"}} ></i></a><br/><hr/>
                    <a href="https://www.instagram.com/rudraxvariya/"><i class="fa fa-instagram" style={{color:"red"}} ></i></a><br/><hr/>
                    <a href="https://github.com/rudraxvariya"><i class="fa fa-github" style={{color:"black"}}></i></a><br/><hr/>
                    <a href="https://www.facebook.com/Rudrax.variya5/"><i class="fa fa-facebook" style={{color:"blue"}} ></i></a><br/>
                    </Card.Footer>
                </Card>
                <Card style={{ height: 400 }}>
                    <Card.Body>
                        <Card.Title><b>SWAPNIL THAKAR</b></Card.Title>
                        <Card.Text>
                            Computer Engineer
                        </Card.Text>
                        <Card.Text>
                            FrontEnd Devloper
                        </Card.Text>
                    </Card.Body>
                    <Card.Footer>
                    <a href="https://www.linkedin.com/in/rudrax-variya-4675a1142"><i class="fa fa-linkedin-square" style={{color:"blue"}} ></i></a><br/><hr/>
                    <a href="https://www.instagram.com/rudraxvariya/"><i class="fa fa-instagram" style={{color:"red"}} ></i></a><br/><hr/>
                    <a href="https://github.com/rudraxvariya"><i class="fa fa-github" style={{color:"black"}}></i></a><br/><hr/>
                    <a href="https://www.facebook.com/Rudrax.variya5/"><i class="fa fa-facebook" style={{color:"blue"}} ></i></a><br/>
                    </Card.Footer>
                </Card>
            </CardDeck>
        </div>
    )
}
